import $ from 'jquery'
import debounce from 'lodash/debounce'

$(function initJumpToStream() {
  $(document).on(
    'autocomplete:selected',
    '.js-message-stream-jump',
    function handleJumpToStream(event, item) {
      window.location.href = item.url
    }
  )
})

$(function initStreamIdGenerator() {
  const LOADING_CLASS = 'u-is-loading-input'
  const VISIBILITY_CLASS = 'u-anim-opacity--zero'

  const $labelContainer = $('.js-stream-id-container')
  const $label = $('.js-stream-id-label')
  const $form = $('.js-message-stream-form')
  const $nameInput = $('.js-stream-name-input')
  const $formRow = $nameInput.parent()

  function fetchStreamId() {
    if ($nameInput.val().trim().length === 0) {
      $labelContainer.addClass(VISIBILITY_CLASS)
      $formRow.removeClass(LOADING_CLASS)
      $label.text('')
      return
    }

    $formRow.addClass(LOADING_CLASS)

    $.post($nameInput.data('preview-url'), $form.serialize())
      .done(response => {
        $label.text(response.id)
      })
      .fail(() => {
        $label.text('error generating ID :(')
      })
      .always(() => {
        $labelContainer.removeClass(VISIBILITY_CLASS)
        $formRow.removeClass(LOADING_CLASS)
      })
  }

  $nameInput.on('keyup', debounce(fetchStreamId, 300))
})

$(function preventDoubleSubmission() {
  // This was necessary to prevent re-submitting this form in Safari
  // https://wildbit.atlassian.net/browse/PM-7018
  // It's weird that Safari allows for that.

  const $form = $('.js-message-stream-form')
  $form.on('submit', event => {
    if ($form.data('submitted')) {
      event.preventDefault()
      return false
    }
    $form.data('submitted', true)
  })
})
